const addUniqueNotifications = (state, notifications, existingNotifications) => {
    const existingIds = new Set(existingNotifications.map(notification => notification.id));
    const newNotifications = notifications.filter(notification => !existingIds.has(notification.id));
    state.unshift(...newNotifications);
};

export default {
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  setAddNotification(state, { notification, type }) {
    state[type].push(notification);
  },
  setUpdateNotifications(state, newNotifications) {
    
    if (!newNotifications) return;
    
    const uniqueNotifications = newNotifications.filter((newNotification) => {
      return !state.notifications.some(
        (existingNotification) => existingNotification.id === newNotification.id
      );
    });

    state.notifications = [...uniqueNotifications, ...state.notifications];
  },
  setUnreadNotificationsCount(state, payload) {
    state.unreadNotificationsCount = payload;
  },
  setUnreadNotifications(state, payload) {
    addUniqueNotifications(state.unreadNotifications, payload.results, state.unreadNotifications);
  },
  setReadNotifications(state, payload) {
    state.readNotificationsCount = payload.count;
    addUniqueNotifications(state.readNotifications, payload.results, state.readNotifications);
  },
  setIsNotificationLoaded(state, payload) {
    state.isLoaded = payload;
  },
  setNotificationsCount(state, payload) {
    state.count = payload;
  },  
  setRemoveNotification(state, { notification, type }) {   
    const index = state[type].findIndex(n => n.id === notification.id);
    if (index !== -1) {
        state[type].splice(index, 1);   
    }
  },

  // setIsRead(state, notificationId) {
  //   const notification = state.notifications.find(
  //     (n) => n.id === notificationId
  //   );
  //   if (notification) {      
  //     notification.read = true;
  //     console.log(notification);
  //   }
  // },

  setClearNotifications(state){
    state.notifications = [];
  }
};
